import React from 'react'
import Media from 'react-media'

import Accordion from '@cinch/oxd-components/accordion/src'
import { Facebook, Instagram, Twitter } from '@cinch/oxd-components/icons/src'
import Link from '@cinch/oxd-components/link/src'
import SVG from '@cinch/oxd-components/svg/src'
import GlobalContext from '@cinch/oxd-utils/context/src'
import tokens from '@cinch/oxd-utils/tokens/src'

import * as styles from './footer-new.module.css'

const buttonSize = tokens.customProperties.spacing.l

export interface Link {
  title: string
  url: string
  icon?: React.ReactNode
  external?: boolean
}

export interface Column {
  title: string
  items: Link[]
}

export interface FooterProps {
  buttons?: Link[]
  columns?: Column[]
}

const defaultButtons = [
  { title: 'Twitter', url: 'https://twitter.com/cinchuk', icon: Twitter, external: true },
  { title: 'Facebook', url: 'https://facebook.com/cinchuk', icon: Facebook, external: true },
  { title: 'Instagram', url: 'https://instagram.com/cinchuk', icon: Instagram, external: true },
]

const renderColumn = (column: Column) => (
  <nav>
    <ul className={styles.footerList}>
      {column.items.map((item, index) => (
        <li className={styles.footerListItem} key={index}>
          <Link className={styles.footerListLink} to={item.url} external={item.external} title={item.title}>
            {item.title}
          </Link>
        </li>
      ))}
    </ul>
  </nav>
)

export const Footer: React.FC<FooterProps> = ({ buttons = defaultButtons, columns = [] }) => (
  <footer className={styles.footer}>
    {buttons && !!buttons.length && (
      <nav data-testid="icons" className={styles.iconsNav}>
        {buttons.map(({ title, url, icon, external }) => (
          <Link
            className={styles.iconLink}
            target="_blank"
            rel="noopener noreferrer"
            key={url}
            to={url}
            external={external}
            title={title}
          >
            <SVG size={buttonSize} children={icon} />
          </Link>
        ))}
      </nav>
    )}
    <div className={styles.footerColumns}>
      {columns.map((column, index) => (
        <div key={index} className={styles.footerListColumn}>
          <Media query={tokens.customMedia.m}>
            {(matches) =>
              matches ? (
                <>
                  <h6 className={styles.footerListTitle}>{column.title}</h6>
                  {renderColumn(column)}
                </>
              ) : (
                <Accordion
                  label={column.title}
                  customStyles={{
                    label: styles.accordionTitle,
                    container: styles.accordionContainer,
                    containerExpanded: styles.accordionContainerExpanded,
                    icon: styles.accordionIcon,
                    button: styles.accordionButton,
                  }}
                  iconSize={tokens.customProperties.spacing.l}
                >
                  {renderColumn(column)}
                </Accordion>
              )
            }
          </Media>
        </div>
      ))}
    </div>
  </footer>
)

const ContextFooter = (props: any) => (
  <GlobalContext.Consumer>
    {({ footerColumns }: Cinch.Context) => <Footer {...props} columns={footerColumns} />}
  </GlobalContext.Consumer>
)

export default ContextFooter
